export default __webpack_public_path__ + "static/media/header-a.dd73aec0.png";